import React, {
    Component
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { DatePicker, TimePicker, Space } from 'antd';

class WOReSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "Work Order Reschedule",
        }
    }
    _doNavToWOAdd = () => {
        this.props.navigate("/WorkOrder");
    }
    render() {
        return (
            <div className="wrapper">
                <Header title={this.state.title} />
                <Menu1 />
                <div className='content-wrapper'>
                    <section className='content top-space'>
                        <div className="m-panel">
                            <div className="m-panel__body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select date*</label>
                                            <DatePicker className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select time*</label>
                                            <TimePicker format="HH:mm" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Add comment*</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <div className="m-page__button top-space">
                                    <button type='button' onClick={this._doNavToWOAdd} className='btn muted-button  deca-btn-orange'>Back</button>
                                    <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        )
    }
}

export default WOReSchedule;